import { MemberInvestmentEntryType } from '../types/investmentApi.types'
import { UNITS } from '../../../types/misc.types'
import { InvestmentRowModel } from '../types/investmentSection.types'

export function buildSecondaryInvestmentRowModel({
  member,
  index
}: {
  member: MemberInvestmentEntryType
  index: number
}): InvestmentRowModel {
  const userName = (member?.userName ?? '').trim() || 'Family'
  const firstName = userName?.split(' ')?.[0]?.trim() || 'Family'

  const key = member?.userName?.trim() || member?.folioDetails?.[0]?.folioNumber || `member-${index}`

  return {
    key,
    titleLeadingText: firstName,
    titleTrailingText: "'s Investment",
    iconInitial: firstName?.charAt(0)?.toUpperCase() || '',
    investmentDataOverride: {
      currentGain: member?.currentGain ?? { amount: 0, unit: UNITS.RUPEES },
      investedAmount: member?.investedAmount ?? { amount: 0, unit: UNITS.RUPEES },
      investmentDetails: member?.investmentDetails ?? {
        puInvestmentAmount: { amount: 0, unit: UNITS.RUPEES },
        externalInvestmentAmount: { amount: 0, unit: UNITS.RUPEES }
      },
      sipAmount: member?.sipAmount ?? { amount: 0, unit: UNITS.RUPEES },
      fundReturns: member?.fundReturns ?? {
        fundAmount: { amount: 0, unit: UNITS.RUPEES },
        returns: { unit: UNITS.PERCENTAGE, value: 0 }
      },
      oneDayReturns: member?.oneDayReturns ?? {
        fundAmount: { amount: 0, unit: UNITS.RUPEES },
        returns: { unit: UNITS.PERCENTAGE, value: 0 }
      },
      xirr: member?.xirr ?? null,
      lifeTimeXirr: member?.lifeTimeXirr,
      averageNav: member?.averageNav ?? { amount: 0, unit: UNITS.RUPEES },
      balancedUnits: member?.balancedUnits ?? 0,
      firstInvestmentTimeStamp: member?.firstInvestmentTimeStamp ?? 0,
      folioDetails: member?.folioDetails ?? [],
      throughFamilyAccess: true,
      secondaryUserName: '',
      primaryUserName: ''
    },
    temporaryFamilyAccessToken: member?.temporaryFamilyAccessToken ?? ''
  }
}
